import React from 'react';
import { PLACE_TYPE_CATEGORIES } from '../constants/placeTypes';

const PlaceTypeSelector = ({ selectedTypes, onChange }) => {
  return (
    <div className="options" data-tip="walk.types">
      <label htmlFor="placeType">Typ av plats/service:</label>
      <select
        id="placeType"
        multiple
        size="10"
        value={selectedTypes}
        onChange={(e) => {
          const selected = Array.from(e.target.selectedOptions).map(option => option.value);
          onChange(selected);
        }}
      >
        {PLACE_TYPE_CATEGORIES.map(category => (
          <optgroup key={category.label} label={category.label}>
            {category.options.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </optgroup>
        ))}
      </select>
    </div>
  );
};

export default PlaceTypeSelector;
